const passwordError =
  "^Password does not meet our security requirements.\n";
const requiredMsg = "^Required";

export const lengthRegex = /.{6,}/;
export const specialCharRegex = /.*[- !"#$%&'()*+,.\\/:;<=>?@[\\\]^_`{|}~]+.*/;
export const numberRegex = /.*[0-9]+.*/;
export const wordsToExclude = [
  "ebsco",
  "dynamed",
  "ehost",
  "admin",
  "password",
  "pa$$word",
  "p@$$",
  "pa$$",
  "p@ss",
];

export const containsExcludedWords = (input) => {
  return wordsToExclude.some((substring) =>
    input.toLowerCase().includes(substring)
  );
};

export const matchesLengthRegex = (input) => {
  return lengthRegex.test(input);
};

export const matchesNumberRegex = (input) => {
  return numberRegex.test(input);
};

export const matchesSpecialCharRegex = (input) => {
  return specialCharRegex.test(input);
};

export const getConstraints = (organizationContext) => {
  let constraints = {
    username: {
      presence: {
        message: requiredMsg,
      },
      email: {
        message: "^Please enter valid email address.",
      },
    },
    password: {
      presence: {
        message: requiredMsg,
      },
      password: {
        message: passwordError,
      },
    },
    firstname: {
      presence: {
        message: requiredMsg,
      },
    },
    lastname: {
      presence: {
        message: requiredMsg,
      },
    },
    specialty: {
      presence: {
        message: requiredMsg,
      },
    },
    role: {
      presence: {
        message: requiredMsg,
      },
    },
  };

  if (!organizationContext) {
    constraints.organization = {
      presence: {
        message: requiredMsg,
      },
    };
  }

  return constraints;
};
